export default {
  closeModal: 'closeModal',
};

export const modalType = {
  cancelTransactionModal: 'cancelTransactionModal',
  helpTransactionModal: 'helpTransactionModal',
  errorBlockTransactionModal: 'errorBlockTransactionModal',
  aivfTransactionInfoModal: 'aivfTransactionInfoModal',
  limitCheckDetailsModal: 'limitCheckDetailsModal',
};



// WEBPACK FOOTER //
// ./components/transaction/src/actions/onModalAction/actionType.js